







// Dependencies
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';

@Component ({
	computed: mapState (['tag']),
	methods: mapActions (['getTag'])
})
export default class Home extends Vue
{
	// Properties

	errorMessage: string = '';



	// Events

	async mounted ()
	{
		try
		{
			await this.loadTag ();
			// @ts-ignore
			if (this.tag.registered)
				this.$router.push ('/contact');
			else
				this.$router.push ('/register');
		}
		catch (e)
		{
			this.errorMessage = e.message;
		}
	}



	// Methods

	async loadTag ()
	{
		// @ts-ignore
		if (this.tag)
			return;
		if (!this.$route)
			throw new Error ('No route found');
		if (!this.$route.query)
			throw new Error ('No query found');
		if (!this.$route.query.t)
			throw new Error ('No tag ID found');
		const id = this.$route.query.t;
		// @ts-ignore
		await this.getTag (id);
	}
}

